<template>
  <div class="process-container card p-0">
    <div v-if="orderSummary" class="order-summary">
      <div class="card-header header-title">ご注文内容の確認</div>

      <div class="card-body">
        <table class="table">
          <tbody>
            <tr>
              <th class="custom-title">お名前</th>
              <td>
                {{ cartStore.cart.billingAddressData.name01 }}
                {{ cartStore.cart.billingAddressData.name02 }}
              </td>
            </tr>
            <tr>
              <th class="custom-title">住所</th>
              <td>
                〒{{ cartStore.cart.billingAddressData.zip01
                }}{{ cartStore.cart.billingAddressData.zip02 }}
                {{ findByCode(cartStore.cart.billingAddressData.prefectureId)?.name }}
                {{ cartStore.cart.billingAddressData.addr01 }}
                {{ cartStore.cart.billingAddressData.addr02 }}
              </td>
            </tr>
          </tbody>
        </table>

        <table class="price-summary" :class="tableClass">
          <thead class="fs-7 fw-bold">
            <tr>
              <th>商品名</th>
              <th>単価</th>
              <th>個数</th>
              <th>小計</th>
            </tr>
          </thead>
          <tbody v-if="orderSummary">
            <tr v-for="(variant, index) in orderSummary.variants" :key="index">
              <td style="white-space: pre-line" class="w-50 text-break">
                {{ variant.name }}
              </td>
              <td>{{ filters.currency(variant.salesPrice) }}</td>
              <td>{{ variant.quantity }} 個</td>
              <td>{{ filters.currency(variant.total) }}</td>
            </tr>
            <tr>
              <td class="text-end fw-bold" colspan="3">小計</td>
              <td>{{ filters.currency(orderSummary.subtotal) }}</td>
            </tr>
            <tr v-if="orderSummary.discount || orderSummary.couponCode">
              <td class="text-end fw-bold" colspan="3">割引</td>
              <td>-{{ filters.currency(orderSummary.discount || 0) }}</td>
            </tr>
            <tr>
              <td class="text-end fw-bold" colspan="3">送料</td>
              <td>{{ filters.currency(orderSummary.delivFee) }}</td>
            </tr>
            <tr>
              <td class="text-end fw-bold" colspan="3">手数料</td>
              <td>{{ filters.currency(orderSummary.charge) }}</td>
            </tr>
            <tr>
              <td class="text-end fw-bold" colspan="3">消費税</td>
              <td>{{ filters.currency(orderSummary.tax) }}</td>
            </tr>
            <tr>
              <td class="text-end fw-bold" colspan="3">合計</td>
              <td class="text-danger fw-700">{{ filters.currency(orderSummary.total) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { findByCode } from "jp-prefectures";
import filters from "@/composables/filters";
import { PublicsOrdersPricesType } from "@/types/publics/orders/PricesType";
import { useCartStore } from "@/stores/cart";

type PropsType = {
  orderSummary: PublicsOrdersPricesType | null;
};
const props = defineProps<PropsType>();

const cartStore = useCartStore();
const tableClass = "table table-column-bordered gy-4 gx-2 gs-9 mb-6";
</script>

<style scoped>
.header-title {
  background-color: #000a4c;
  color: #fff;
}

.custom-title {
  color: black;
}

.table {
  th,
  td {
    padding: 5px 4px !important;
  }
}

.price-summary {
  td:last-child,
  th:last-child {
    text-align: right !important;
    width: 50px;
  }
}
</style>
